import styled from 'styled-components'

import MainLayout from '../../layouts/MainLayout'
import Baggy from '../../components/atoms/Baggy'
import { mq, sizes } from '../../theme'

export const Layout = styled(MainLayout)``
export const Bag = styled(Baggy)`
  & > * > * {
    padding: 3rem 2rem;

    @media ${mq(sizes.tablet)} {
      padding: 5rem 4rem;
    }
  }
`
